import { Api } from 'utils';

class SupportService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/support-chats',params),
		send: async (params?: any) => Api.createResponse('admin/support-chats/send',params),
		view: async (params?: any) => Api.createResponse('admin/support-chats/view',params),
		uploadFile: async (params = {}) => Api.createResponse('admin/support-chats/upload-file',params),
		changeStatus: async (params = {}) => Api.createResponse('admin/support-chats/change-status',params),
	}

}

export default SupportService;